export const API_URL = `https://equbszd8yb.execute-api.ap-southeast-2.amazonaws.com/v1/staging`;
export const API_V2_URL = `https://prod-api-v2.benchvote.com`;
export const LEADFORM_URL = `https://activation.benchvote.com`;
export const ECARDS_URL = `https://ecards.benchvote.com`;




// WEBPACK FOOTER //
// ./src/util/Constants.js